import _slicedToArray from "/builds/M9cfiv79/0/everlywell/apps/www/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useState } from "react";
import * as S from "./styles";
import { ProductsList, ProductsListHeader } from "./ProductsList";
import { FullQuotaZeroState, NoTestsZeroState } from "./ProductsListEmpty";
import productsConfig from "./config";
export function Products(_ref) {
  var _ref$source = _ref.source,
      t = _ref$source === void 0 ? "taker" : _ref$source,
      e = _ref.productsList,
      r = _ref.isQuotaFull,
      a = _ref.truncationStrategy,
      o = _ref.sanitationStrategy,
      c = _ref.onClick,
      n = _ref.onCancel;

  var _useState = useState(!1),
      _useState2 = _slicedToArray(_useState, 2),
      s = _useState2[0],
      u = _useState2[1],
      l = 0 === (null == e ? void 0 : e.length);

  return React.createElement(React.Fragment, null, r ? React.createElement(FullQuotaZeroState, null) : l ? React.createElement(NoTestsZeroState, null) : React.createElement(React.Fragment, null, React.createElement(ProductsListHeader, {
    source: t
  }), React.createElement(ProductsList, {
    productsList: e,
    truncationStrategy: a,
    sanitationStrategy: o
  })), React.createElement(S.ProductsButtonGroup, {
    reverse: !0
  }, React.createElement(S.PrimaryButton, {
    hasArrow: !0,
    source: t,
    appearance: "primary",
    isLoading: s,
    onClick: function onClick(t) {
      u(!0), c && c(t);
    },
    disabled: l || r
  }, productsConfig[t].button.text), n && React.createElement(S.SecondaryButton, {
    onClick: n,
    appearance: "secondary"
  }, "Cancel")));
}
export default Products;